import { render, staticRenderFns } from "./leftContainer.vue?vue&type=template&id=453f2ecb&scoped=true&"
import script from "./leftContainer.vue?vue&type=script&lang=js&"
export * from "./leftContainer.vue?vue&type=script&lang=js&"
import style0 from "./leftContainer.vue?vue&type=style&index=0&id=453f2ecb&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "453f2ecb",
  null
  
)

export default component.exports